const PREFIX = 'swr_';
const DEFAULT_TTL = 5 * 60 * 1000;

// Zawartość działu jest malowana z cache'u natychmiast, jeszcze przed fetchem —
// więc wpis o NIEAKTUALNYM kształcie ląduje na ekranie jako gotowa lista.
// Rozszerzenie przeszło z podtematów na szablony, stąd `v2`: bump wersji jest
// jedynym sposobem, żeby stare wpisy nikomu się nie pokazały. Zmieniasz kształt
// odpowiedzi field-details → podnieś numer.
export const fieldDetailsCacheKey = (fieldId) => `field_details_v2_${fieldId}`;

export function readApiCache(key, ttl = DEFAULT_TTL) {
    try {
        const raw = localStorage.getItem(PREFIX + key);
        if (!raw) return null;
        const { data, ts } = JSON.parse(raw);
        if (Date.now() - ts > ttl) return null;
        return data;
    } catch { return null; }
}

export function writeApiCache(key, data) {
    try {
        localStorage.setItem(PREFIX + key, JSON.stringify({ data, ts: Date.now() }));
    } catch {}
}

export function invalidateApiCache(key, blocking = false) {
    localStorage.removeItem(PREFIX + key);
    window.dispatchEvent(new CustomEvent('api-cache-invalidated', { detail: { key, blocking } }));
}

// Oznacza cache jako nieswiezy, ale ZACHOWUJE dane (ustawia ts=0). Ekran-konsument czytajacy
// wprost z cache pokaze stare dane od razu (bez pustki/flasha) i odswiezy w tle
// (stale-while-revalidate). Uzywac zamiast invalidate tam, gdzie ekran nie ma kontekstu
// trzymajacego dane w pamieci (np. SurefiresScreen czyta surefire-atoms wprost z cache).
export function expireApiCache(key) {
    try {
        const raw = localStorage.getItem(PREFIX + key);
        if (!raw) return;
        const { data } = JSON.parse(raw);
        localStorage.setItem(PREFIX + key, JSON.stringify({ data, ts: 0 }));
    } catch {}
}

// Zapisuje swieze dane user_dashboard_data do local storage: cache SWR + skrot `userStatus`,
// ktory czytaja naglowki/ekrany jako fallback. Uzywac przy KAZDYM wymuszonym pobraniu
// user_dashboard_data/, zeby lokalne dane nie zostawaly w tyle za swiezo pobranym API.
export function persistDashboardData(data) {
    if (!data) return;
    writeApiCache('user_dashboard_data', data);
    if (data.account_status) {
        try { localStorage.setItem('userStatus', JSON.stringify(data.account_status)); } catch {}
    }
    // Powiadom zywy kontekst (UserDashboardContext), zeby ekrany czytajace `dashboardData`
    // (np. gate dostepu na Dashboard) od razu dostaly swieze dane, a nie tylko local storage.
    window.dispatchEvent(new CustomEvent('dashboard-data-updated', { detail: { data } }));
}
